import React from 'react';
import { Link } from 'react-router';
import Button from '@ordermentum/ui-shared/atoms/Button';
import { EXTERNAL_LINKS } from '@ordermentum/ui-constants';
import { Card } from '../../Card';
import Background from '../../Background';
import {
  TextContainer,
  Container,
  ContentContainer,
  ButtonContainer,
  Header,
  Text,
  CTA,
} from './Error.style';

const ErrorPage = () => (
  <Background>
    <Card>
      <Container>
        <ContentContainer>
          <Header>Oh no!</Header>
          <TextContainer>
            <Text>
              Something went wrong when we tried to sign you up for a demo.
            </Text>
            <ButtonContainer>
              <Link to="/register">
                <Button type="primary" size="large">
                  TRY AGAIN
                </Button>
              </Link>
            </ButtonContainer>
            <Text>
              If the problem persists please{' '}
              <CTA href={EXTERNAL_LINKS.SUPPORT.CONTACT}> contact us</CTA>
            </Text>
          </TextContainer>
        </ContentContainer>
      </Container>
    </Card>
  </Background>
);

export { ErrorPage };
